// IceObs Azure Environment Configuration

export const environment = {
  production: false,
  appFlavor: 'iceobs',

  api: {
    baseUrl: 'https://api-test.ymparisto.fi/citobs',
    extension: true,
    apimSubscriptionKey: '507d6c8028c3438c8eadefa8b759116a'
  },

  azure: {
    // IceObs-specific Azure AD B2C configuration
    clientId: 'ICEOBS-CLIENT-ID', // TODO: Replace with actual client ID
    authority: 'https://sykecitobs.b2clogin.com/sykecitobs.onmicrosoft.com/B2C_1_SignUpSignIn',
    knownAuthorities: ['sykecitobs.b2clogin.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,

    // Storage configuration
    storageUrl: 'https://sykecitobsstorage.blob.core.windows.net',
    containerName: 'iceobs-uploads',
    sasToken: '', // Not needed - backend handles storage

    // API Scopes
    apiScopes: [],

    // Image upload API URL (same as api.baseUrl, backend appends /images)
    imageApiUrl: 'https://api-test.ymparisto.fi/citobs'
  },

  useAzureStorage: true,
  useAzureAuth: true,

  // Disabled Firebase config (kept for reference/rollback)
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: ""
  }
};